<script>
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'

export default {
  components: { TheHeader, TheFooter },
}
</script>

<template>
  <div>
    <TheHeader class="header" />
    <slot />
    <TheFooter />
  </div>
</template>

<style lang="scss">
/* Import Google Font */
@import url('https://fonts.googleapis.com/css2?family=Noto+Serif+TC:wght@400;500;700&display=swap');

$color-primary: #e3c192;
$color-secondary: #9c9fb0;

body {
  font-family: 'Noto Serif TC', serif;
}

/* Background */
.is-fade {
  background: transparent linear-gradient(180deg, rgb(192, 151, 93, 0.15) 0%, #c0975d00 100%) 0% 0% no-repeat padding-box;
}

/* Banner Content */
.dingbeauty-banner-content {
  width: 100%;
  color: #fff;
  text-align: center;
  position: relative;
  top: 50vh;
  transform: translateY(-50%);

  p {
    margin-bottom: 0;
    font-size: 16px;
    line-height: 1.8;
  }

  .sub-title {
    font-size: 22px;
  }

  .title {
    font-size: 40px;
    margin-bottom: 1rem;
    line-height: 2;
  }
}

@media (min-width: 992px) {
  .dingbeauty-banner-content {
    text-align: left;
    top: 350px;

    .title {
      font-size: 50px;
    }
  }
}

/* Section Title */
.dingbeauty-sub-title {
  color: $color-primary;
  text-align: center;
  font-size: 16px;
  margin-bottom: 16px !important;
}

.dingbeauty-title {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  margin-bottom: 2rem;
  text-align: center;

  &.is-dotted {
    &::after {
      content: '';
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: $color-primary;
      margin-left: 14px;
    }

    &::before {
      content: '';
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: $color-primary;
      margin-right: 14px;
    }
  }
}

@media (min-width: 992px) {
  .dingbeauty-sub-title {
    font-size: 22px;
  }
  .dingbeauty-title {
    font-size: 40px;
    margin-bottom: 60px;

    &.is-small {
      margin-bottom: 30px;
    }
  }
}

/* Button */
.dingbeauty-btn {
  width: 200px;
  display: block;
  color: #fff;
  background-color: $color-primary;
  padding: 18px 20px;
  text-align: center;
  font-size: 16px;
  transition: all 0.3s;
  line-height: 1;
  border: 1px solid $color-primary;
  margin: 0 auto;

  .email-icon {
    width: 18px;
    margin-right: 8px;
  }

  &:focus {
    outline: 0;
  }

  &:hover {
    color: #fff;
    text-decoration: none;
    background-color: #ccae83;
  }

  &.is-full {
    width: 100%;
  }

  &.is-mobile {
    width: 100%;
  }

  &.is-outline {
    color: $color-secondary;
    border-color: $color-secondary;
    background-color: #fff;

    &:hover {
      color: $color-primary;
      border-color: $color-primary;
    }
  }

  &.is-loading {
    opacity: 0.5;
    cursor: wait;
  }
}

@media (min-width: 992px) {
  .dingbeauty-btn {
    &.is-mobile {
      width: 200px;
    }
  }
}

/* Switch */
.dingbeauty-switch--container {
  max-width: 400px;
  margin: 0 auto;
  margin-bottom: 30px;
}

.dingbeauty-switch {
  .el-tabs__item {
    height: 46px;
    padding: 0;
    transition: all 0.3s;

    &:hover {
      color: $color-primary;
    }

    &.is-active {
      color: $color-primary;
    }
  }

  .el-tabs__active-bar {
    background-color: $color-primary;
  }
}

@media (min-width: 768px) {
}
</style>
